import styled from 'styled-components';

import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';

import {Column} from '../../common/Layouts/Layouts';

export const GoRatingBlock = styled(Column)(props => {
  return `
      background-color: ${getRatingsColor(props.hotelRating)};
      align-items: center;
      justify-content: center;
      width: 14.5rem;
      color: ${props.theme.colors.goWhite.base};
      border-radius: ${props.theme.misc.borderRadius.large};
    `;
});

export const GoRatingTextWrapper = styled.p(
  props => `
    font-size: ${props.theme.font.custom(22)};
    align-items: center;
    padding-top: ${props.theme.spacing.base};
    padding-bottom: ${props.theme.spacing.small};
  `,
);

export const ReviewCountTextWrapper = styled.p(
  props => `
    font-size: ${props.theme.font.custom(14)};
    align-items: center;
    padding-top: ${props.theme.spacing.small};
    padding-bottom: ${props.theme.spacing.small};
  `,
);

export const RatingsCountTextWrapper = styled(Column)(
  props => `
    font-size: ${props.theme.font.custom(14)};
    align-items: center;
    padding-bottom: ${props.theme.spacing.base};
  `,
);

export const AvgReviewTextWrapperDiv = styled.p(
  props => `
    flex-direction: row;
    align-items: flex-end;
  `,
);

export const AvgReviewTextWrapper = styled.span(
  props => `
    font-size: 3.8rem;
    align-items: center;
    font-weight: 600;
  `,
);

export const TotalReviewTextWrapper = styled.span(
  props => `
    font-size: 2.6rem;
    align-items: center;
    font-weight: 600;
  `,
);
